import { ID } from "@datorama/akita";
import { Location } from "../../locations/state/location.model";
import { Employee } from "../../contact-persons/state/employee.model";
import { Log } from "../../contact-moments/state/log.model";
import { Document } from "../../documents/state/document.model";
import { Stakeholder } from "../../stakeholders/state/stakeholder.model";
import { Resident } from "../../residents/state/resident.model";
import { Action } from "../../tasks/state/action.model";
import { Issue } from "../../issues/state/issue.model";

export const ComplaintStatus = {
  OPEN: "open",
  PENDING: "pending",
  CLOSED: "closed",
} as const;

export type ComplaintStatusType =
  (typeof ComplaintStatus)[keyof typeof ComplaintStatus];

export type Sentiment = {
  id: number;
  sentimentable_id: number;
  sentimentable_type: string;
  sentiment_score: number;
  user_score: number;
  created_at: string;
  updated_at: string;
};
export type Complaint = {
  closed_date?: Date;
  complainant_address?: string;
  complainant_city?: string;
  complainant_country?: string;
  complainant_email?: string;
  complainant_latitude?: number;
  complainant_longitude?: number;
  complainant_name?: string;
  complainant_phone?: string;
  complainant_postcode?: string;
  complaints_documents?: any[];
  complaintthemes?: any;
  complaintthemes_id?: number;
  coordinates?: any;
  date?: Date;
  deadline?: Date;
  days_open?: number;
  final_logs_id?: number;
  id?: ID;
  closed_description?: string;
  residents?: Resident;
  residents_id?: number;
  source?: string;
  status?: ComplaintStatusType;
  project_code?: string;
  stakeholders?: Stakeholder[];
  stakeholders_id?: number;
  contactpersons?: Employee;
  linked_contactpersons?: Employee[];
  employees_id?: number;
  text: string;
  users?: any[];
  subprojects?: any[];
  shared_projects?: any[];
  shared_item_status?: string;
  locations?: Location;
  contactmoments?: Log[];
  tasks?: Action[];
  requirements?: any;
  issues?: Issue[];
  workflows?: any;
  final_logs_description?: string;
  final_logs?: Log;
  documents?: Document[];
  priority?: any;
  relatics_uuid?: boolean;
  enableChatModal?: boolean;
  closed_by?: {};
  sentiments?: Sentiment[];
  inbox_id?: number | null;
  inbox_status?: string | null;
  ticket_id?: number | string;
  entry_type?: string;
};

export function createComplaint(text: string): Complaint {
  return {
    text: text,
  };
}
